module.exports = __webpack_public_path__ + "img/tiktok-iconbar.c23f159e.svg";